import { Card } from "@mantine/core";
import DynamicFormBuilder from "../FormBuilder/DynamicFormBuilder.component";
import { useSingleForm } from "../../../../api/services/useServices";

export default function ApplicationSignupForm() {
  const { data: singleForm, isSuccess: isFormLoaded } = useSingleForm({
    params: {
      module_type: "application",
    },
  });

  return (
    <Card radius="md">
      {isFormLoaded && (
        <DynamicFormBuilder
          singleForm={singleForm}
          onSubmit={{
            successPage: "/application-signup/success",
            callback: () => {
              // localStorage.setItem("isApplication", "true-signup");
            },
          }}
          isPublicForm
        />
      )}
    </Card>
  );
}
